import { useState, useCallback } from "react"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { Input } from "../components/ui/input"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select"
import { cn } from "../lib/utils"

const COUNTRY_CODES = ["+1", "+44", "+82", "+81", "+49", "+33", "+86", "+91"]

export function PhoneInputRenderer({ element }: RendererProps) {
  const { dispatchEvent } = useRenderContext()
  const [code, setCode] = useState("+1")
  const [phone, setPhone] = useState("")

  const dispatch = useCallback(
    (countryCode: string, phoneNumber: string) => {
      dispatchEvent(element.id, "change", { countryCode, phoneNumber })
    },
    [element.id, dispatchEvent],
  )

  return (
    <div
      className={cn("flex flex-row gap-2 items-center", element.className)}
      data-testid={`phone-input-${element.id}`}
    >
      <Select
        value={code}
        onValueChange={(v) => {
          if (v === null) return
          setCode(v)
          dispatch(v, phone)
        }}
      >
        <SelectTrigger className="h-9 w-auto" aria-label="Country code">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {COUNTRY_CODES.map((c) => (
            <SelectItem key={c} value={c}>
              {c}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        type="tel"
        placeholder={element.placeholder ?? "(555) 123-4567"}
        value={phone}
        onChange={(e) => {
          setPhone(e.target.value)
          dispatch(code, e.target.value)
        }}
        aria-label={element.ariaLabel ?? "Phone number"}
      />
    </div>
  )
}
